export default "__VITE_ASSET__kxvzJRGz__"